import React from "react"
import { withRouter, Link } from "react-router-dom"
import Logo from "../../assets/img/Logo.svg"

import DesktopMenus from "./DesktopMenus"
import MobileMenus from "./MobileMenus"

function Navbar({ location }) {
  const menus = [
    {
      pathname: "/",
      label: "home"
    },
    {
      pathname: "/aboutus",
      label: "aboutus"
    },
    {
      pathname: "/campaign",
      label: "campaigns"
    },
    {
      pathname: "/merchandise",
      label: "merchandises"
    }
  ]

  return (
    <>
      <nav uk-navbar="true" className="navbar">
        <div className="navbar-logo">
          <img src={Logo} alt="logo" width="50" className="navbar-logo-img" />
          <Link className="navbar-title uk-text-bold" to="/">
            Anak Indonesia Bersatu
          </Link>
        </div>
        <button
          className="uk-navbar-toggle uk-margin-left"
          uk-navbar-toggle-icon="true"
          uk-toggle="target: #mobile-menus"
        ></button>

        <DesktopMenus menus={menus} />
      </nav>

      <MobileMenus menus={menus} />
    </>
  )
}

export default withRouter(Navbar)
